import { ForkEffect, takeEvery } from 'redux-saga/effects';
import { Socket } from 'socket.io-client';

import { send } from '../send-request';
import {
  carrierCreatePacket,
  carrierServicesLoad,
  carrierSyncPacketStatus,
} from './reducer';

export function* watch(
  socket: Socket,
): Generator<ForkEffect<never>, void, string> {
  yield takeEvery(carrierServicesLoad.type, send, socket);
  yield takeEvery(carrierCreatePacket.type, send, socket);
  yield takeEvery(carrierSyncPacketStatus.type, send, socket);
}
